if (!("performance" in window))
{
  const timeOrigin = Date.now();
  window.wPerformance = {
    now() {
      return Date.now() - timeOrigin;
    }
  }
}
else
{
  window.wPerformance = performance;
}

function wait_for(ms)
{
  return new Promise(
    resolve => setTimeout(resolve, ms));
}

function skip()
{
  return Promise.resolve(1);
}

function make(tag, clazz, parent)
{
  const element = document.createElement(tag);

  if (clazz)
    element.classList.add(...clazz
      .split(" ")
      .filter(i => i));

  if (parent)
    parent.appendChild(element);

  return element;
}

make.button = function(clazz, parent, text, link, blank)
{
  const element = make("a", "scenario-button appears " + (clazz || ""), parent);

  element.textContent = text;

  if (link)
    element.href = link;

  if (blank)
    element.target = "_blank";

  return element;
}

class ScenarioDialog
{
  //
  constructor(scenario, container, config = {})
  {
    if (!scenario)
    {
      this.destructed = true;

      return;
    }

    this.container = container;
    this.config = config;
    this.scenario = scenario;
    this.frames = this.scenario.frames;
    this.logs = [];

    wait_for(this.scenario.wait_before || 0)
    .then(() =>
      this.initLayout())
    .then(() =>
      this.logAppear())
    .then(() =>
      this.renderFrame(this.frames[this.scenario.first_frame]))
  }

  //
  initLayout()
  {
    const location = this.scenario.geometry
      && this.scenario.geometry.location;
    const main = make("div",
      "scenario-dialog appears " + (location || ""), this.container);

    main.innerHTML = `
    <div class="scenario-dialog__header">
      <div class="scenario-dialog__userpic scenario-image">
        <img src="${this.scenario.image}" alt="Proglib" />
        <div class="scenario-dialog__online"></div>
      </div>
      <div class="scenario-dialog__title">
        ${this.scenario.title}
      </div>
      <div class="scenario-dialog__close-btn">
        <img src="https://image.flaticon.com/icons/svg/59/59836.svg" style="width: 16px; height: 16px;" />
      </div>
    </div>
    <div class="scenario-dialog__content">
      <div class="wrapper" style="overflow-y: auto">
      </div>
    </div>
    <div class="scenario-dialog__input">
      <div class="scenario-dialog__largepic scenario-image">
        <img src="${this.scenario.image}" alt="Proglib" />
      </div>
      <div class="scenario-dialog__preview">
      </div>
    </div>`;

    this.main = main;

    this.main.querySelector(
      ".scenario-dialog__close-btn")
      .onclick = () => this.close(this.scenario.close_id);

    return wait_for(1)
    .then(() => this.main.classList.remove("appears"));
  }

  //
  renderFrame(frame)
  {
    if (typeof frame === "string")
    {
      if (frame in this.frames)
        frame = this.frames[frame];
      else
        return this.renderVirtualFrame(frame);
    }

    // ожидание перед фреймом
    // если есть
    //
    return (frame.wait_before ?
      wait_for(frame.wait_before)
      : skip())
    // пререндер
    // если есть
    .then(() => {
      if (frame.prerender)
        return this.renderFrame(frame.prerender)

      return skip();
    })
    // превью фрейма
    // если есть
    .then(() => {
      if (frame.preview)
        return this.renderFrame(frame.preview);

      return skip();
    })
    // рендер фрейма
    .then(() => {
      switch (frame.type)
      {
        case "print":
        return this.renderFramePrint(frame);
        case "message":
        return this.renderFrameMessage(frame);
        case "branch":
        return this.renderFrameBranch(frame);
      }

      return skip();
    })
    // ожидание после фрейма
    // если есть
    .then(() => {
      if (frame.wait_after)
        return wait_for(frame.wait_after);

      return skip();
    })
    // после рендеринга
    // если есть
    .then(() => {
      const promise = skip();

      if (frame.then)
      {
        frame.then.map(item =>
          promise.then(() => this.renderFrame(item)));
      }

      return promise;
    })
    .then(() => {
      if (frame.next)
        return this.renderFrame(frame.next);

      return skip();
    });
  }

  //
  renderVirtualFrame(frame)
  {
    if (typeof this[frame] === "function")
      return this[frame]();

    return skip();
  }

  //
  renderFramePrint(frame)
  {
    const input = this.main.querySelector(
      ".scenario-dialog__input");
    const printElement = input.querySelector(
      ".printing") || make("div",
      "message-item printing", input);
    
    if (printElement.innerHTML)
    {
      printElement.classList.remove("disappears");
    }
    else
    {
      printElement.innerHTML = "<div class='printing-text'>Печатает<span>.</span><span>.</span><span>.</span></div>"
    }

    return wait_for(frame.duration)
    .then(() => {
      if (!frame.after) frame.after = "remove";

      switch (frame.after)
      {
        case "remove": 
        input.removeChild(printElement);
        break;
        case "clear":
        printElement.classList.add("disappears");
        break;
      }
    });
  }

  //
  renderFrameMessage(frame)
  {
    const content = this.main.querySelector(
      ".scenario-dialog__content .wrapper");
    const msg = make("div", "content-item message-item appears " + (frame.style || ""), content);

    msg.textContent = frame.content;

    return wait_for(0)
    .then(() => msg.classList.remove("appears"));
  }

  //
  renderFrameBranch(frame)
  {
    const content = this.main.querySelector(
      ".scenario-dialog__content .wrapper");
    const input = this.main.querySelector(
      ".scenario-dialog__input");
    const parentContainer = make("div", "flex", (frame.in_input ? input : content));
    const container = make("div", "content-item branch-buttons", parentContainer);
    const btnsElements = [];

    for (const button of frame.buttons)
    {
      let link = false;
      let blank = false;
      
      switch (button.type)
      {
        case "new_tab_link":
        blank = true;
        link = button.href;

        case "this_tab_link":
        link = button.href;
      }

      const btn = make.button(button.style,
        container, button.content, link, blank);

      btnsElements.push(btn);

      switch (button.type)
      {
        case "new_tab_link":
        btn.onclick = () => {
          this.close(button.id || button.content);

          // const promise = Promise.resolve(1);

          // if (button.then)
          // {
          //   button.then.forEach(i => promise.then(this.renderFrame(i)));
          // }
        };
        break;

        case "frame_link":
        btn.onclick = () => {
          this.log(button.id || button.content);
          this.renderFrame(button.href);
        };
        break;

        case "close":
        btn.onclick = () => {
          this.close(button.id || button.content);
        };
        break;
        case "this_tab_link":
        btn.onclick = () => {
          this.log(button.id || button.content);
          this.flush();
        };
        break;
      }
    }

    return wait_for(0)
    .then(() => btnsElements.forEach(
      b => b.classList.remove("appears")));
  }

  //
  log(id)
  {
    this.logs.push({
      id: id,
      type: "click",
      time: wPerformance.now(),
      url: window.location.href
    });
  }

  //
  logAppear()
  {
    fetch(`/api/scenario/${this.scenario.id}/updateViews`, {
      method: "POST"
    })
    .catch(e => 0);

    return skip();
  }

  //
  flush()
  {
    if (!this.config.noAnalytics)
    {
      const data = new FormData();

      this.logs.forEach((item, index) =>
      {
        Object.keys(item).forEach((key) => {
          data.append(`logs[${index}][${key}]`, item[key]);
        });
      });

      fetch("/api/scenario/log", {
        method: "POST",
        body: data
      })
      .then(res => res.json())
      .then(json => console.log(json))
      .catch(error => console.error(error));

      this.seen();
    }
  }

  //
  seen()
  {
    const age = 60 * 60 * 24 * 30;
    document.cookie = `seenScenarioDialog=seenScenarioDialog; max-age=${age}; path=/;`;
  }

  //
  close(source)
  {
    this.log(source);

    this.main.classList.add("removed", "appears");
    this.flush();
  }

  //
  clear()
  {
    const content = this.main.querySelector(
      ".scenario-dialog__content .wrapper");

    if (!content) return;
    
    const children = [];

    for (const item of content.children)
    {
      item.classList.add("disappears");
      
      children.push(item);
    }

    return wait_for(500)
    .then(() => {
      for (const item of children)
      {
        content.removeChild(item);
      }
    });
  }
}

export { ScenarioDialog };
